"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentConfiguration = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const core_1 = require("@veeam/core");
const components_2 = require("../../../../components");
const constants_1 = require("../../../../constants");
const core_2 = require("../../../../core");
require("./types");
const CurrentConfiguration = ({ model }) => {
    const { platformName } = core_2.useProductContext();
    const { t } = core_2.useFeatureContext();
    const { value: modelValue } = core_1.useModel(model);
    return (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, gap: components_1.STACK_GAP.l },
        react_1.default.createElement(components_1.NoteBar, { status: components_1.NOTEBAR_STATUS.info },
            react_1.default.createElement("div", { style: { whiteSpace: 'pre-wrap' } }, t('configurationBackup|currentConfiguration|helpText|message', {
                platform: platformName,
            }))),
        react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, gap: components_1.STACK_GAP.s },
            react_1.default.createElement(components_1.TitleH2, { style: { whiteSpace: 'pre-wrap' } }, t('configurationBackup|currentConfiguration|header')),
            react_1.default.createElement(components_2.TableKeyValue, { items: [
                    {
                        label: t('configurationBackup|currentConfiguration|form|fields|managedBy|label'),
                        value: modelValue.managedBy || constants_1.EMPTY_TEXT.dash,
                    },
                    {
                        label: t('configurationBackup|currentConfiguration|form|fields|repository|label'),
                        value: modelValue.repositoryName,
                    },
                    {
                        label: t('configurationBackup|currentConfiguration|form|fields|keepRestorePoints|label'),
                        value: modelValue.retentionCount,
                    },
                ] }))));
};
exports.CurrentConfiguration = CurrentConfiguration;
//# sourceMappingURL=CurrentConfiguration.js.map